import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  VStack,
  HStack,
  Text,
  Box,
  Divider,
  Grid,
  Badge,
} from '@chakra-ui/react';
import { SaktiBkmListItem } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiBkmDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: SaktiBkmListItem | null;
}

const SaktiBkmDetailModal: React.FC<SaktiBkmDetailModalProps> = ({ isOpen, onClose, data }) => {
  if (!data) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent borderRadius={SAKTI_UI_SIZE.cardRadius}>
        <ModalHeader bg="customGreen.500" color="white" borderRadius={`${SAKTI_UI_SIZE.cardRadius} ${SAKTI_UI_SIZE.cardRadius} 0 0`}>
          Detail BKM
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody py={6}>
          <VStack align="stretch" spacing={4}>
            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
              <Box>
                <Text fontSize="xs" color="gray.500">Pemanen</Text>
                <Text fontWeight="bold">{data.harvester_name}</Text>
                <Text fontSize="xs" color="gray.500">{data.harvester_nip}</Text>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Foreman</Text>
                <Text fontWeight="bold">{data.foreman_name}</Text>
                <Text fontSize="xs" color="gray.500">{data.foreman_nip}</Text>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Tanggal</Text>
                <Text fontWeight="semibold">{data.bkm_date}</Text>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Estate / Divisi</Text>
                <Text fontWeight="semibold">{data.estate_name} - {data.division_name}</Text>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Status</Text>
                <Badge colorScheme={data.status === 'ACTIVE' ? 'blue' : 'gray'}>{data.status}</Badge>
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500">Hanca Count</Text>
                <Text fontWeight="semibold">{data.hanca_count}</Text>
              </Box>
            </Grid>
            <Divider />
            <Box>
              <Text fontSize="xs" color="gray.500" mb={2}>Realisasi HA & Penalti</Text>
              <VStack align="stretch" spacing={4}>
                <Box>
                  <Text fontSize="2xl" fontWeight="bold">{data.ha_amt.toFixed(2)}</Text>
                  <Text fontSize="xs" color="gray.500">HA TOTAL</Text>
                </Box>
                <Grid templateColumns="repeat(4, 1fr)" gap={4}>
                  <Box><Text fontWeight="bold">{data.p01.toFixed(2)}</Text><Text fontSize="xx-small">P01 (Prod)</Text></Box>
                  <Box><Text fontWeight="bold">{data.p02.toFixed(2)}</Text><Text fontSize="xx-small">P02 (Qual)</Text></Box>
                  <Box><Text fontWeight="bold">{data.p03.toFixed(2)}</Text><Text fontSize="xx-small">P03 (Attn)</Text></Box>
                  <Box><Text fontWeight="bold">{data.p04.toFixed(2)}</Text><Text fontSize="xx-small">P04 (Eqp)</Text></Box>
                  <Box><Text fontWeight="bold">{data.p05.toFixed(2)}</Text><Text fontSize="xx-small">P05 (Safe)</Text></Box>
                  <Box><Text fontWeight="bold">{data.p06.toFixed(2)}</Text><Text fontSize="xx-small">P06 (Insub)</Text></Box>
                  <Box><Text fontWeight="bold">{data.p07.toFixed(2)}</Text><Text fontSize="xx-small">P07 (Other)</Text></Box>
                </Grid>
              </VStack>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter bg="gray.50" borderRadius={`0 0 ${SAKTI_UI_SIZE.cardRadius} ${SAKTI_UI_SIZE.cardRadius}`}>
          <Button onClick={onClose}>Tutup</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SaktiBkmDetailModal;
